function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import appApis, { validateError } from '@/services/services';
import axios from 'axios';
import tasks from '@/js/tasks';
import trae from 'trae';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var key = 'key=' + process.env.VUE_APP_API_KEY;
// declare service gtw
var appApisGTW = null;
if (!configuration['audiences']) {
  appApisGTW = axios.create({
    //baseURL: process.env.VUE_APP_CR_AUDIENCIAS
    baseURL: "http://localhost:8000"
    //baseURL: "https://crun-itc-dp-audience-intercorp-qmuzefzuga-uc.a.run.app"
  });
} else {
  appApisGTW = axios.create({
    //baseURL: process.env.VUE_APP_CR_AUDIENCIAS ercq
    baseURL: process.env.VUE_APP_API_GTW
    //baseURL: "http://localhost:8000"
    //baseURL: "https://crun-itc-dp-audience-intercorp-qmuzefzuga-uc.a.run.app"
  });
}
/* const beforeMiddleware = (config) => {
    // tasks.getUserInfo()
    config.headers['Authorization'] = "Bearer " + window.userInfo.accessToken
    return config
}

appApisGTW.before(beforeMiddleware)
*/
setupInterceptors(appApisGTW);
var loginObj = function loginObj() {
  return {
    email: window.userInfo.email,
    tokenId: window.userInfo.accessToken,
    localId: window.userInfo.localId
  };
};
var CONTROLLER_NAME = '/user_profiles';
var DOMAIN_AREAS = '/areas';
var DOMAIN_USER_PROFILES = '/profiles';
var DOMAIN_TABLES = '/tables';
var DOMAIN_ASSIGNMENTS = '/assignments';
export default {
  getSegmentos: function getSegmentos(codEmpresa) {
    var _this = this;
    var with_audience = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/segments/list?company_code=' + codEmpresa + '&' + key + "&with_audience=" + with_audience, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this.getSegmentos(codEmpresa);
      });
    });
  },
  getTiposSegmento: function getTiposSegmento() {
    var _this2 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };

    // tasks.lockScreen.lock()
    return appApisGTW.get('/audience-management/segments/segment-type/list?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      // tasks.lockScreen.unlock()
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this2.getTiposSegmento();
      });
    });
  },
  crearSegmentoCruce: function crearSegmentoCruce(data) {
    var _this3 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/crossing-segment/create?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this3.crearSegmentoCruce(data);
      });
    });
  },
  editarSegmentoCruce: function editarSegmentoCruce(data, segment_code) {
    var _this4 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.put('/audience-management/crossing-segment/' + segment_code + '/edit?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this4.editarSegmentoCruce(data);
      });
    });
  },
  createSegment: function createSegment(data) {
    var _this5 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/crossing-segment/create?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this5.createSegment(data);
      });
    });
  },
  getVisualizationCruce: function getVisualizationCruce(data) {
    var _this6 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post('/audience-management/crossing-segment/preview?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      return res.data;
    }).catch(function (err) {
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this6.getVisualizationCruce(data);
      });
    });
  },
  getSegmentById: function getSegmentById(data) {
    var _this7 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/segments/' + data.segment_code + '/retrieve?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this7.getSegmentById(data);
      });
    });
  },
  getAttributes: function getAttributes(data) {
    var _this8 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/custom-segment/attribute/' + data.company_code + '/list?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this8.getAttributes(data);
      });
    });
  },
  getAttributeOptions: function getAttributeOptions(data) {
    var _this9 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/attribute/' + data.attribute_code + '?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this9.getAttributeOptions(data);
      });
    });
  },
  validateAccess: function validateAccess(data) {
    var _this0 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApis.post('/verificar/verificar', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this0.validateAccess(data);
      });
    });
  },
  obtenerServiceAccount: function obtenerServiceAccount(data) {
    var _this1 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/service-account/retrieve?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this1.obtenerServiceAccount(data);
      });
    });
  },
  getVisualizationAttributes: function getVisualizationAttributes(data) {
    var _this10 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post('/audience-management/custom-segment/preview?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this10.getVisualizationAttributes(data);
      });
    });
  },
  guardarSegmentoAtributos: function guardarSegmentoAtributos(data) {
    var _this11 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/custom-segment/create?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this11.guardarSegmentoAtributos(data);
      });
    });
  },
  editSegmentoAtributos: function editSegmentoAtributos(data, segment_code) {
    var _this12 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.put('/audience-management/custom-segment/' + segment_code + '/edit?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this12.guardarSegmentoAtributos(data);
      });
    });
  },
  eliminarSegmento: function eliminarSegmento(codigo_segmento, company_code) {
    var _this13 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.put('/audience-management/segments/' + codigo_segmento + '/deactivate?company_code=' + company_code, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this13.eliminarSegmento(codigo_segmento, company_code);
      });
    });
  },
  getSharedWith: function getSharedWith(segment_code) {
    var body = {};
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/segments/' + segment_code + '/share/list', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  setSharedWith: function setSharedWith(segment_code, data) {
    var body = data;
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/segments/' + segment_code + '/share', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  removeSharedWith: function removeSharedWith(segment_code, sharing_id) {
    var body = {};
    tasks.lockScreen.lock();
    return appApisGTW.put('/audience-management/segments/' + segment_code + '/share/' + sharing_id + '/remove', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  duplicarSegmento: function duplicarSegmento(segment_code, data) {
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/segments/' + segment_code + '/duplicate', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getDataMergeSegment: function getDataMergeSegment() {
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/merge-segment/attribute/list', {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getPrevieMergeSegment: function getPrevieMergeSegment(data) {
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/merge-segment/preview', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      console.log(res);
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  createMergeSegment: function createMergeSegment(data) {
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/merge-segment/create', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  editMergeSegment: function editMergeSegment(segment_code, data) {
    tasks.lockScreen.lock();
    return appApisGTW.put('/audience-management/merge-segment/' + segment_code + '/edit', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getRestrictions: function getRestrictions() {
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/company/restriction/list', {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  updateRestriction: function updateRestriction(companyCode, restrictions) {
    tasks.lockScreen.lock();
    return appApisGTW.put('/audience-management/company/' + companyCode + '/restriction/update', restrictions, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getUseCases: function getUseCases(companyCode) {
    return appApisGTW.get('/audience-management/sandbox-segment/use-case', {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      return res.data;
    });
  },
  getPreviewSandboxSegment: function getPreviewSandboxSegment(data) {
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/sandbox-segment/preview', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      console.log(res);
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  createSandboxSegment: function createSandboxSegment(data) {
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/sandbox-segment/create', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  editSandboxSegment: function editSandboxSegment(segment_code, data) {
    tasks.lockScreen.lock();
    return appApisGTW.put('/audience-management/sandbox-segment/' + segment_code + '/edit', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getRequestAccess: function getRequestAccess(status) {
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/segment/request-access?request_status=' + status, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  saveRequestAccess: function saveRequestAccess(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/segment/request-access', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  acceptRequestAccess: function acceptRequestAccess(access_request_id, request_until_date, type) {
    //console.log(type)
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var update = type == 3 ? true : false;
    var body = {
      login: login,
      request_until_date: request_until_date
    };
    body.update = update;
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/segment/request-access/' + access_request_id + '/approve', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  declineRequestAccess: function declineRequestAccess(access_request_id) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/segment/request-access/' + access_request_id + '/decline', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getCompanyAccess: function getCompanyAccess() {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/segment/company-access', {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getCompanyFlags: function getCompanyFlags() {
    return appApisGTW.get('/audience-management/segment/company-flags', {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      return res.data;
    });
  },
  getCompanyFlagsByCompanyCode: function getCompanyFlagsByCompanyCode(company_code) {
    return appApisGTW.get('/audience-management/segment/company-flags?company_code=' + company_code, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      return res.data;
    });
  },
  getAllCompanyFlags: function getAllCompanyFlags() {
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/segment/all-company-flags', {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getAllCompanyAds: function getAllCompanyAds(fecha) {
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/segment/ads-account/' + fecha + '', {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getSegmentsRequestAccepted: function getSegmentsRequestAccepted() {
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/segments/list_request_accepted', {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getDetailsSegmentRequested: function getDetailsSegmentRequested(state, segment_code) {
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/segment/request-access-changed?request_status=' + state + '&code=' + segment_code, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  saveFlagsCompany: function saveFlagsCompany(body) {
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/segment/flags-company-save', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  massiveAcceptRequestAccess: function massiveAcceptRequestAccess(data) {
    //console.log(type)
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var update = false;
    var requests = data;
    var body = {
      login: login,
      requests: requests
    };
    body.update = update;
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/segment/request-access/massive-approve', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  massiveDeclineRequestAccess: function massiveDeclineRequestAccess(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var requests = data;
    var body = {
      login: login,
      requests: requests
    };
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/segment/request-access/massive-decline', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getAttributeRestriction: function getAttributeRestriction() {
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/segment/attribute-restriction', {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  saveAttributeRestriction: function saveAttributeRestriction(body) {
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/segment/attribute-restriction', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  saveAdsAccount: function saveAdsAccount(body) {
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/segment/ads-account', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  verificarAccount: function verificarAccount(company_code) {
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/segment/verify-ads-account/' + company_code, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  segment_insert_campaign: function segment_insert_campaign(body) {
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/segment/insert-campaign', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  }
};